// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Popular {
  padding: 2em 0;
  margin-top: 7em;
  overflow: hidden;
}
.Popular__title {
  line-height: 1.3;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/Popular/popular.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AACJ;AACI;EACI,gBAAA;EACA,SAAA;AACR","sourcesContent":[".Popular {\n    padding: 2em 0;\n    margin-top: 7em;\n    overflow: hidden;\n\n    &__title {\n        line-height: 1.3;\n        margin: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
